/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotTotalsByModelFeature extends models.CopilotActivityBase {
    getFixupPrototypeFunction() { return CopilotTotalsByModelFeature.fixupPrototype; }

    static newInstance(model: Partial<CopilotTotalsByModelFeature>): CopilotTotalsByModelFeature {
        let obj = Object.assign(new CopilotTotalsByModelFeature(), model);
        CopilotTotalsByModelFeature.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotTotalsByModelFeature>): CopilotTotalsByModelFeature {
        if (!model) return null;
        return CopilotTotalsByModelFeature.newInstance(<CopilotTotalsByModelFeature> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotTotalsByModelFeature) {
        if (!obj) return;

        models.CopilotTotalsByModelFeature.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotTotalsByModelFeature): boolean {
        if (models.CopilotActivityBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotTotalsByModelFeature.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Feature name (e.g. code_completion)
     */
    feature: string;

    /**
     * AI model name (e.g. gpt-4.1)
     */
    model: string;

}
